import React, { useEffect } from 'react';
import './PostProjectButton.css'; 
import { Center, Button } from '@chakra-ui/react';

const PostProjectButton = ({ onClick }) => {
  useEffect(() => {
    localStorage.removeItem('form_id'); 
  }, []);

  return (
    <Center className="post-project-button-container">
      <div className="button-text">
        <p>Elevate Your Projects, Hire with Confidence</p>
      </div>
      <Button
        onClick={onClick}
        className="custom-button"
        
        style={{ backgroundColor: '#fdb702', color: '#ffffff' }}
      >
        POST A PROJECT
      </Button>
    </Center>
  );
};

export default PostProjectButton;
